import React from "react";

import Button from "./Button/Button";

import {ReactComponent as UnlockIcon} from "../../assets/unlock.svg";
import {useWeb3React} from "@web3-react/core";
import { useAuthorizeModal } from '../../hooks';
//import {injected} from "../../connectors";

function UnlockButton({style,className}) {
    // const { activate } = useWeb3React();
    const { showModal } = useAuthorizeModal();

    const onClick = () => showModal();

    return (
        <Button
            className={className}
            style={{
                background: "linear-gradient(92.41deg, rgba(107, 251, 147, 0.8) 13.02%, rgba(187, 246, 167, 0.8) 97.06%), #FFFFFF",
                color: "black",
                border: "none",
                ...style
            }}
            onClick={onClick}
        >
            <div style={{display: "flex", alignItems: "flex-end"}}>
                <UnlockIcon />
                <span style={{marginLeft: 10}}>Unlock Wallet</span>
            </div>
        </Button>
    );
}

export default UnlockButton;
